import { VideoStore } from '../video.store';
import { isInArticleAdUnit } from '../../adUnit';
import {
  ControlsStrategyType,
  ControlsStrategyTypes,
  DefaultControlsStrategy
} from './default-controls-strategy';
import { ConfigStore } from '../config.store';

export class ResponsiveControlsStrategy extends DefaultControlsStrategy {
  type: ControlsStrategyType = ControlsStrategyTypes.RESPONSIVE;

  constructor(
    videoStore: VideoStore,
    config: ConfigStore,
    adContext: Record<string, any>
  ) {
    super(videoStore, config, adContext);
  }

  shouldDisplayVastIcon(): boolean {
    return (
      !isInArticleAdUnit(this.adContext.adUnitType) &&
      super.shouldDisplayVastIcon() &&
      !this.shouldDisplayBrandItem()
    );
  }

  shouldHideOptout(): boolean {
    return this.shouldDisplayVastIcon() && this.configStore.config.optOut.hide;
  }

  // TODO: Use elapsedTime from store
  shouldDisplayCloseButton(elapsedTime: number): boolean {
    const closeBtnConfig = this.configStore.config.closeBtn;
    return Boolean(
      closeBtnConfig &&
        !super.shouldHideCloseButton() &&
        (closeBtnConfig.forceImmediate ||
          elapsedTime >= closeBtnConfig.displayAfter) &&
        !isInArticleAdUnit(this.adContext.adUnitType)
    );
  }

  shouldDisplayBrandItem(): boolean {
    return (
      !isInArticleAdUnit(this.adContext.adUnitType) &&
      super.shouldDisplayBrandItem()
    );
  }

  shouldHideBorderLayer(): boolean {
    return Boolean(
      this.configStore.config.controls &&
        this.configStore.config.controls.responsiveBorderHidden
    );
  }
}
